import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

// Formata como 1.234,56 (separador de milhar "." e decimal ",")
export function formatCurrency(value: number): string {
  const safe = Number.isFinite(value) ? value : 0;
  return safe.toLocaleString("pt-BR", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

// Formata inteiros (sem casas decimais) com separador de milhar: 1.000
export function formatInteger(value: number): string {
  const safe = Number.isFinite(value) ? Math.round(value) : 0;
  return safe.toLocaleString("pt-BR", { maximumFractionDigits: 0 });
}

export function formatPrice(value: number): string {
  return `R$ ${formatCurrency(value)}`;
}
